module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm04_title"
    }
  }), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/title.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center2"
  }, [_c('strong', [_vm._v("OUR 10 FAVORITE INGREDIENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "center2"
  }, [_c('strong', [_vm._v("MATT LEWIS & RENATO POLIAFITO"), _c('br'), _c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTOGRAPHS BY TINA RUPP")])])]), _vm._v(" "), _c('p', {
    staticClass: "center2"
  }, [_c('strong', [_vm._v("STEWART, TABORI & CHANG     NEW YORK")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e27d06a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm04_title.vue
// module id = 69
// module chunks = 0